import axios from 'axios';
import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import successHandle from '../utils/successHandle';
import errorHandle from '../utils/errorHandle';
import Loader from '../utils/Loader';
import RenderError from '../utils/RenderError';
import { isStrongPassword, isValidEmail, isValidPhoneNumber } from '../utils/utils';

document.querySelector('html body').style.background = '#f6f9fa';

const apiEndPoint = process.env.REACT_APP_API_URL + "/api/user/register";
const PASSWORD_STRENGTH = {
  1: "Very weak",
  2: "Weak",
  3: "Meduim",
  4: "Strong",
}

const Register = () => {
  const intialState = {
    loading: false,
    name: '',
    email: '',
    phone: '',
    answer: '',
    answerError: '',
    password: '',
    passwordError: '',
    passwordStatus: '',
    confirmPassword: '',
    confirmPasswordError: '',
    registerError: '',
    emailError: '',
    phoneError: '',
    referId: ''
  }
  const navigate = useNavigate();
  const [state, setCompleteState] = useState(intialState)
  const setState = (newState) => setCompleteState((prevState) => ({ ...prevState, ...newState }))

  useEffect(() => {
    const searchParams = new URLSearchParams(window.location.search);
    const referId = searchParams.get('referId');
    if (referId) {
      setState({ referId });
    }
  }, []);

  const onFocusName = () => setState({ registerError: '' })

  const onFocusEmail = () => setState({ emailError: '', registerError: '' })

  const validateEmail = () => {
    const isValid = isValidEmail(state.email)
    if (!isValid) {
      setState({ emailError: '*Please enter a valid email!' })
    }
  }

  const validatePhoneNumber = () => {
    const { phone } = state;
    if (!phone || !isValidPhoneNumber(phone)) {
      setState({ phoneError: '*Provide valid indian numbers' })
    }
  }

  const onFocusAnswer = () => setState({ answerError: '', ForgotPasswordError: '' })

  const validateAnswer = () => {
    if (!state.answer) {
      setState({ answerError: '*Enter your answer!' })
    }
  }

  const checkStrength = (pass) => {
    if (pass.length > 15) {
      setState({ passwordError: "*Password is too lengthy" })
      return
    }
    else if (pass.length < 8) {
      setState({ passwordError: "*Password is too short" })
      return;
    }

    if (isStrongPassword(pass)) {
      setState({ passwordStatus: 'Password is strong' });
    }

    let count = 0;
    let regex1 = /[a-z]/;
    if (regex1.test(pass)) count++;
    let regex2 = /[A-Z]/;
    if (regex2.test(pass)) count++;
    let regex3 = /[\d]/;
    if (regex3.test(pass)) count++;
    let regex4 = /[!@#$%^&*.?]/;
    if (regex4.test(pass)) count++;
    setState({ passwordError: '', passwordStatus: PASSWORD_STRENGTH[count] })
  }

  useEffect(() => {
    if (!state.password) {
      return;
    }
    checkStrength(state.password)
  }, [state.password]);

  const onFocusPassword = () => setState({ passwordError: '', passwordStatus: '', registerError: '' });

  const validatePassword = () => {
    if (!state.password) {
      setState({ passwordError: '*Please Enter a valid password!' })
    }
  }

  const onFocusConfirmPassoword = () => setState({ confirmPasswordError: '', registerError: '' });

  const validateConfirmPassword = () => {
    const { password, confirmPassword } = state || {}
    if (!confirmPassword) {
      setState({ confirmPasswordError: "*Please enter a valid password!" })
    }
    if (password !== confirmPassword) {
      setState({ confirmPasswordError: '*Password are not matched!' })
    }
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    register()
  }

  const register = async () => {
    setState({ loading: true })
    const { name, email, answer, emailError, password, passwordError, confirmPassword, confirmPasswordError, answerError, referId, phone, phoneError } = state || {}
    const values = name && isValidEmail(email) && password && confirmPassword && answer && isValidPhoneNumber(phone);
    const hasError = emailError || passwordError || confirmPasswordError || answerError || phoneError;
    const isValid = values && !hasError
    if (!isValid) {
      setState({ registerError: '*Plese fill the correct details', loading: false })
      return;
    }

    const data = { name, email, answer, password, phone, referId }
    await axios.post(apiEndPoint, data)
      .then((res) => {
        setState({ loading: false })
        successHandle(res.data.message)
        navigate('/login')
      })
      .catch((error) => {
        setState({ loading: false })
        errorHandle(error)
      })
  }

  return (
    <div className='mt-4 gleamDesk-auth'>
      <div class="container d-flex justify-content-center align-items-center">
        <div class="page-login">
          <div class="text-center">
            <Link class="navbar-brand mb-4 h1" to="/login">
              <img src="assets/img/gleamDesk.png" style={{ height: '8.5rem' }} class="navbar-brand-image d-inline-block align-top mr-2" alt="" />
            </Link>
          </div>

          <div class="card mb-0">
            <div class="card-body">
              <form onSubmit={handleSubmit}>
                <div class="form-group mb-3">
                  <label for="exampleDropdownFormName" class="form-label">Name</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter your name"
                    value={state.name}
                    onFocus={onFocusName}
                    onChange={(e) => setState({ name: e.target.value })}
                    disabled={state.loading}
                  />
                </div>
                <div class="form-group mb-3">
                  <label for="exampleDropdownFormEmail1" class="form-label">Email address</label>
                  <input
                    type="email"
                    class="form-control"
                    id="exampleDropdownFormEmail1"
                    placeholder="email@example.com"
                    value={state.email}
                    onChange={(e) => setState({ email: e.target.value })}
                    onFocus={onFocusEmail}
                    onBlur={validateEmail}
                    disabled={state.loading}
                  />
                  <RenderError error={state.emailError} />
                </div>
                <div class="form-group mb-3">
                  <label className='form-label'>Phone*</label>
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Enter your contact number"
                    value={state?.phone}
                    onChange={(e) => setState({ phone: e.target.value })}
                    onFocus={() => setState({ phoneError: '' })}
                    onBlur={validatePhoneNumber}
                    disabled={state.loading}
                  />
                  <div>
                    <small className='form-text text-muted'>Pattern: +91XXXXXXXXXX</small>
                  </div>
                  <RenderError error={state.phoneError} />
                </div>
                <div class="form-group mb-3">
                  <label for="exampleDropdownFormEmail1" class="form-label">What is your first nickname?</label>
                  <input
                    type="text"
                    class="form-control"
                    id="exampleDropdownFormtext1"
                    placeholder="gleamdesk"
                    value={state.answer}
                    onChange={(e) => setState({ answer: e.target.value })}
                    onFocus={onFocusAnswer}
                    onBlur={validateAnswer}
                    disabled={state.loading}
                  />
                  <RenderError error={state.answerError} />
                </div>
                <div class="form-group mb-3">
                  <label for="referId" class="form-label">Refer ID</label>
                  <input
                    type="text"
                    class="form-control"
                    id="referId"
                    placeholder="Refer ID"
                    value={state.referId}
                    onChange={(e) => setState({ referId: e.target.value })}
                  />
                </div>
                <div class="form-group mb-3">
                  <label for="exampleDropdownFormPassword1" class="form-label">Password</label>
                  <input
                    type="password"
                    class="form-control"
                    id="exampleDropdownFormPassword1"
                    placeholder="Password"
                    value={state.password}
                    onChange={(e) => setState({ password: e.target.value })}
                    onFocus={onFocusPassword}
                    onBlur={validatePassword}
                    disabled={state.loading}
                  />
                  <RenderError error={state.passwordStatus} />
                </div>
                <div class="form-group mb-3">
                  <label for="exampleDropdownFormPassword1" class="form-label">Confirm password</label>
                  <input
                    type="password"
                    class="form-control"
                    id="exampleDropdownFormPassword1"
                    placeholder="Confim password"
                    value={state.confirmPassword}
                    onChange={(e) => setState({ confirmPassword: e.target.value })}
                    onFocus={onFocusConfirmPassoword}
                    onBlur={validateConfirmPassword}
                    disabled={state.loading}
                  />
                  <RenderError error={state.confirmPasswordError} />
                </div>
                <div className='pb-3 text-center'>
                  <Loader isLoading={state.loading} />
                </div>
                <button type="submit" class="btn btn-sm btn-block btn-primary w-100" onClick={handleSubmit} disabled={state.loading}>Register</button>
                <div className='text-center fw-500 mt-2'><small className='text-danger'>
                  <RenderError error={state.registerError} />
                </small></div>

                <div className='mt-3 text-center'>
                  Already have an account? <Link to="/login">Login</Link>
                </div>
              </form>
            </div>
            <div class="card-footer text-center">
              <Link to="/forgot"><small>Forgot your password?</small></Link>
            </div>
          </div>
        </div>
      </div >
    </div >
  )
}

export default Register;
